export default "__VITE_ASSET__BWvolHwQ__ 640w, __VITE_ASSET__BKOIj$UB__ 1024w, __VITE_ASSET__CDRM1YDm__ 1920w";